import { useState } from 'react';

import JobList from '../../components/JobList';

const InternshipPage = () => {
  const [jobCount, setJobCount] = useState(0);

  return (
    <div>
      <div className="grid__container">
        <div className="grid__row content-block" style={{ paddingBottom: '0' }}>
          <div className="grid__column--6 grid__column--mobile-12">
            <p className="page-sub-title">Early careers</p>
            <h1 className="teams-header">Internships</h1>
            <a
              href="#job-list-section"
              className={`button${jobCount === 0 ? ' button--disabled' : ''}`}
              id="explore-jobs-button"
            >
              Explore jobs
            </a>
          </div>
          <div className="grid__column--6">
            <img
              alt="two people"
              className="early-careers-header-svg ls-is-cached lazyloaded"
              src="https://images.skyscnr.com/sttc/jobssite/svg/luggage-4.f887183fdf0ac38e6d76.svg"
            />
          </div>
        </div>
      </div>
      <section
        className="grid__container--full-width tab-content"
        aria-live="polite"
      >
        <article id="engineer-content">
          <div className="grid__container">
            <div className="grid__row" style={{ paddingBottom: '3rem' }}>
              <div className="grid__column--12 grid__column--tablet-12">
                <p>
                  <strong>Internships at Skyscanner</strong>
                </p>
                <p>
                  As an intern at Skyscanner, you’ll be treated like everybody
                  else. We’ll give you an awesome experience where you’ll be a
                  valuable and contributing member to your tribe and squad.
                  You’ll benefit from on-the-job, online and classroom-based
                  learning.
                </p>
                <p>
                  You’ll work hard in your area of the business, learn new
                  skills and be celebrated for what makes you unique to keep
                  Skyscanner dynamic and competitive in an exciting and
                  ever-changing environment.
                </p>
                <p>
                  You can also win an internship with us through our partnership
                  with Undergraduate of the Year. Click the link below to find
                  out more.
                </p>
              </div>
            </div>
          </div>
        </article>
      </section>
      <div className="grid__background--blue mobile-logo-container mobile-logo-container--white">
        <section className="grid__container">
          <div className="grid__row content-block">
            <div className="link-body link-body--left content-block grid__column--12">
              <a
                className="link-body__logo win-internship-logo content-block grid__column--12"
                href="https://www.undergraduateoftheyear.com/awards/software-engineering"
                aria-label="Find out more about the Undergraduate of the year awards"
              />
              <h2 className="win-internship-text">Win a paid internship</h2>
              <p className="win-internship-text">
                We’re proud to be part of the Undergraduate of the Year Awards
                sponsoring two award categories: Software Engineer of the Year
                &amp; AI Innovator of the Year. If you are passionate about
                technology and challenging the status quo, you could win a paid
                internship in Edinburgh, Glasgow or London, plus exclusive
                one-to-one networking opportunities with senior colleagues.
              </p>
              <a
                href="https://www.undergraduateoftheyear.com/awards/software-engineering"
                className="button button--white"
                aria-label="Find out more about the Undergraduate of the year awards"
              >
                Find out more
              </a>
            </div>
          </div>
        </section>
      </div>
      <div className="grid__background--gray mobile-logo-container mobile-logo-container">
        <section className="grid__container">
          <div className="grid__row content-block">
            <div className="link-body link-body--right content-block grid__column--12">
              <a
                className="link-body__logo win-internship-logo content-block grid__column--12"
                href="https://www.undergraduateoftheyear.com/awards/ai-innovator"
                aria-label="Find out more about the AI Innovator of the Year award"
              />
              <h2>AI Innovator of the Year</h2>
              <p>
                We’re proud to be part of the Undergraduate of the Year Awards
                sponsoring the AI Innovator of the Year category. If you are
                passionate about AI and challenging the status quo, you could
                win a paid internship in Edinburgh, Glasgow or London, plus
                exclusive one-to-one networking opportunities with senior
                colleagues.
              </p>
              <a
                href="https://www.undergraduateoftheyear.com/awards/ai-innovator"
                className="button"
                aria-label="Find out more about the AI Innovator of the Year award"
              >
                Find out more
              </a>
            </div>
          </div>
        </section>
      </div>
      <div className="grid__background--blue-and-gray">
        <section className="grid__container">
          <div className="grid__row row--center-align">
            <div className="links-row">
              <div className="link-body link-body--left content-block grid__column--6">
                <a
                  className="link-body__logo win-internship-logo content-block grid__column--12"
                  href="https://www.undergraduateoftheyear.com/awards/software-engineering"
                  aria-label="Find out more about the Undergraduate of the year awards"
                />
                <h2 className="win-internship-text">Win a paid internship</h2>
                <p className="win-internship-text">
                  We’re proud to be part of the Undergraduate of the Year Awards
                  sponsoring two award categories: Software Engineer of the Year
                  &amp; AI Innovator of the Year. If you are passionate about
                  technology and challenging the status quo, you could win a
                  paid internship in Edinburgh, Glasgow or London, plus
                  exclusive one-to-one networking opportunities with senior
                  colleagues.
                </p>
                <a
                  href="https://www.undergraduateoftheyear.com/awards/software-engineering"
                  className="button button--white"
                  aria-label="Find out more about the Undergraduate of the year awards"
                >
                  Find out more
                </a>
              </div>
              <div className="link-body link-body--right content-block grid__column--6">
                <a
                  className="link-body__logo win-internship-logo content-block grid__column--12"
                  href="https://www.undergraduateoftheyear.com/awards/ai-innovator"
                  aria-label="Find out more about the AI Innovator of the Year award"
                />
                <h2>AI Innovator of the Year</h2>
                <p>
                  We’re proud to be part of the Undergraduate of the Year Awards
                  sponsoring the AI Innovator of the Year category. If you are
                  passionate about AI and challenging the status quo, you could
                  win a paid internship in Edinburgh, Glasgow or London, plus
                  exclusive one-to-one networking opportunities with senior
                  colleagues.
                </p>
                <a
                  href="https://www.undergraduateoftheyear.com/awards/ai-innovator"
                  className="button"
                  aria-label="Find out more about the AI Innovator of the Year award"
                >
                  Find out more
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section className="grid__container">
        <div className="grid__row row--center-align content-block">
          <div className="grid__column--7 desktop-only">
            <p className="quote">
              “My internship at Skyscanner has been such a rewarding experience.
              I’ve had the fantastic opportunity to work on real projects, ask
              endless questions, and gain insight into what it’s like to work in
              the industry. The environment has been hugely welcoming and
              supportive, with so many chances to learn from incredibly talented
              people with a wide range of backgrounds and expertise. I’ve come
              away with new skills, greater confidence, and memories I’ll carry
              with me into the future.”
            </p>
            <p className="sub-heading">Jamie Mottashead, Summer Intern, 2026</p>
          </div>
          <div className="grid__column--5 grid__column--tablet-12 photo-container--right">
            <img
              className="photo"
              alt="Jamie Mottashead, Summer Intern, 2026"
              src="https://content.skyscnr.com/asset/f7b1698c-8c68-478f-b663-9215d6947009/Light/jamie.jpg"
            />
          </div>
          <div className="grid__column--tablet-12 mobile-and-tablet-only">
            <p className="quote">
              “My internship at Skyscanner has been such a rewarding experience.
              I’ve had the fantastic opportunity to work on real projects, ask
              endless questions, and gain insight into what it’s like to work in
              the industry. The environment has been hugely welcoming and
              supportive, with so many chances to learn from incredibly talented
              people with a wide range of backgrounds and expertise. I’ve come
              away with new skills, greater confidence, and memories I’ll carry
              with me into the future.”
            </p>
            <p className="sub-heading">Jamie Mottashead, Summer Intern, 2026</p>
          </div>
        </div>
      </section>
      <JobList
        department="Internships"
        setJobCountCallback={(count) => setJobCount(count)}
      />
    </div>
  );
};

export default InternshipPage;
